export default __webpack_public_path__ + "static/media/cover.116b31e3.png";